import { lightTheme } from "@/customTheme"
import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <path
      fill={props.disabled ? lightTheme.colors.grayScale200 : lightTheme.colors.blackGray}
      fillRule="evenodd"
      d="M1.996 4.533a2.537 2.537 0 0 1 2.537-2.537h9.504a2.537 2.537 0 0 1 2.538 2.537v9.5a2.537 2.537 0 0 1-2.538 2.538H4.533a2.537 2.537 0 0 1-2.537-2.538v-9.5Zm2.537-.9a.9.9 0 0 0-.9.9v9.5a.9.9 0 0 0 .9.9h9.504a.9.9 0 0 0 .9-.9v-9.5a.9.9 0 0 0-.9-.9H4.533Z"
      clipRule="evenodd"
    />
    <path
      fill={props.disabled ? lightTheme.colors.grayScale200 : lightTheme.colors.blackGray}
      fillRule="evenodd"
      d="M17.463 7.06h-1.731V5.425h1.731A2.537 2.537 0 0 1 20 7.96v9.5a2.537 2.537 0 0 1-2.537 2.537H7.96a2.537 2.537 0 0 1-2.537-2.537V15.74h1.637v1.722a.9.9 0 0 0 .9.9h9.504a.9.9 0 0 0 .9-.9v-9.5a.9.9 0 0 0-.9-.9Z"
      clipRule="evenodd"
    />
    <path
      fill={props.disabled ? lightTheme.colors.grayScale200 : lightTheme.colors.blackGray}
      fillRule="evenodd"
      d="m12.92 18.646 5.818-5.818 1.157 1.158-5.818 5.817-1.157-1.157ZM8.291 18.645l3.612-3.612 1.158 1.158-3.612 3.612-1.158-1.158ZM15.092 11.844l3.594-3.594 1.157 1.158-3.594 3.594-1.157-1.158ZM5.557 16.751l1.766-1.767 1.158 1.158-1.767 1.767-1.157-1.158ZM14.951 7.354 16.7 5.605l1.158 1.158-1.75 1.749-1.157-1.158Z"
      clipRule="evenodd"
    />
  </svg>
)
export default SvgComponent
